module.exports = __webpack_public_path__ + "static/media/listen.d1ba3232.svg";